"use strict";
var Observable_1 = require("../../Observable");
var combineAll_1 = require("../../operator/combineAll");
Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
//# sourceMappingURL=combineAll.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/combineAll.js
 ** module id = 273
 ** module chunks = 1
 **/